import React, { useState } from 'react';
import { useAbility } from '@casl/react';
import { AbilityContext } from '../../../config/abilityContext';
import CardImage from '../../../components/Utils/Cards/CardImage';
import { SimpleCenteredModal } from '../../../components';
import AnnouncementNotify from '../../CompanyAnnouncement/AnnouncementNotify';

const CompanyAnnouncementCard = ({ announcement, rrhh, location, onDelete, showInfo, showEdit }) => {
  const ability = useAbility(AbilityContext);
  const canEditAnnouncement = ability.can('update', 'CompanyAnnouncement');
  const image = announcement.companyAnnouncementImage?.fileUrl || '';
  const [modalShow, setModalShow] = useState(false);
  const [modalBody, setModalBody] = useState(null);
  const [modalTitle, setModalTitle] = useState('');

  const handleReminder = () => {
    setModalTitle('Notificación de Anuncio');
    setModalBody(<AnnouncementNotify announcement={announcement} hideModal={() => setModalShow(false)} />);
    setModalShow(true);
  };

  return (
    <>
      <CardImage
        classNameDescription="b-description-dash"
        item={announcement}
        image={image}
        location={location}
        rrhh={rrhh}
        canEdit={canEditAnnouncement}
        showInfo={() => showInfo(announcement)}
        showEdit={() => showEdit(announcement)}
        resend={() => handleReminder()}
        onDelete={() => onDelete(announcement)}
      />
      <SimpleCenteredModal
        size="lg"
        title={modalTitle}
        body={modalBody}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default CompanyAnnouncementCard;
